// Language
import { Score } from '../interfaces/Score';

export const getEnvironmentApiUrl = () => {
    return window.config.API_URL;
};

export const validateNonEmpty = (name: string) => {
    return name.trim() !== '' || 'field_required';
};

export const validatePPS = (pps: string) => {
    const parsedNum = Number(pps);
    return (pps.trim() !== '' && parsedNum <= 100 && parsedNum >= 0 && parsedNum % 10 === 0) || 'value_between_0_100_and_multiple_10';
};

// checks if number that could be NaN are equal
export const equalNumsWithNaN = (numberA: number, numberB: number) => {
    if (isNaN(numberA) && isNaN(numberB)) return true;
    else if ((isNaN(numberA) && !isNaN(numberB)) || (!isNaN(numberA) && isNaN(numberB))) return false;
    else return numberA === numberB;
};

// compares dates ('DD-MM-YYYY HH:mm:ss') and returns 1 0 or -1 depending on the result
export const compareDates = (a: string, b: string) => {

    const compareNums = (aNum: string, bNum: string) => {
        if (parseInt(aNum) === parseInt(bNum)) return 0;
        return parseInt(aNum) > parseInt(bNum) ? -1 : 1;
    };

    const [aDay, aMonth, aYearHour] = a.split('-');
    const [bDay, bMonth, bYearHour] = b.split('-');
    const [aYear, aHHMMSS] = aYearHour.split(' ');
    const [bYear, bHHMMSS] = bYearHour.split(' ');
    const [aHour, aMinutes, aSeconds] = aHHMMSS.split(':');
    const [bHour, bMinutes, bSeconds] = bHHMMSS.split(':');

    if (compareNums(aYear, bYear) !== 0) return compareNums(aYear, bYear);
    else if (compareNums(aMonth, bMonth) !== 0) return compareNums(aMonth, bMonth);
    else if (compareNums(aDay, bDay) !== 0) return compareNums(aDay, bDay);
    else if (compareNums(aHour, bHour) !== 0) return compareNums(aHour, bHour);
    else if (compareNums(aMinutes, bMinutes) !== 0) return compareNums(aMinutes, bMinutes);
    else if (compareNums(aSeconds, bSeconds) !== 0) return compareNums(aSeconds, bSeconds);
    return 1;
};

export const getCVParams = (cellID: number) => {
    if (cellID === 109) return { sheet_parameter_id: 'FC_EKG', name: 'hr' };
    if (cellID === 110) return { sheet_parameter_id: 'PULSIOX', name: 'SpO' };
    if (cellID === 111) return { sheet_parameter_id: 'PA_S', name: 'systolic_pressure' };
    if (cellID === 112) return { sheet_parameter_id: 'PA_D', name: 'diastolic_pressure' };
    if (cellID === 113) return { sheet_parameter_id: 'TEMP', name: 'temperature' };
    if (cellID === 114) return { sheet_parameter_id: 'WEIGHT', name: 'weight' };
    if (cellID === 118) return { sheet_parameter_id: 'VIG', name: 'VIG' };
    return null;
};

export const getScore = (cellID: number, scores: Score[] | null) => {
    const score = scores?.find(sc => sc.id === cellID - 1000);
    return score ?? null;
};